export default __webpack_public_path__ + "static/media/first-watch-me.2d9b0ca4.mp3";